import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Help as HelpComp } from 'modules/help'

import { accordion } from './data'
import { HelpProps } from './help.model'

const Help: FC<HelpProps> = memo(({ toggleLoanTerm }) => {
  if (toggleLoanTerm) {
    for(const key in accordion){
        accordion[key].title = accordion[key].title.replace('empréstimo', 'crédito')
        for(const keyItem in accordion[key].item){
        if (accordion[key].item[keyItem].type == 'text') {
          const content = accordion[key].item[keyItem].content as string 
          accordion[key].item[keyItem].content = content.replace('empréstimo', 'crédito')
        }
      }
    }
  }
  
  return (
    <HelpComp accordion={accordion}>
      <Text className="subtitle" size="caption" weight="medium" uppercase>
        Ajuda
      </Text>
      <Text as="h2" size="heading3" weight="medium">
        <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
          Tire as suas <br />
        </Text>
        dúvidas
      </Text>
      <Text className="description" color="var(--colors-neutral-text-weak)">
        Confira as perguntas mais frequentes sobre o Financiamento para Construção.
      </Text>
    </HelpComp>
  )
})

Help.displayName = 'Help'

export default Help
